import { Component, Input } from '@angular/core';
import { AlertsService } from '../../services/alerts/alerts.service';


@Component({
    selector: 'shared-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    imports: []
})
export class AlertComponent {

  public alertState = { show: false, text: '', backgroundColor: '',icon: '' };

  constructor(private alertService: AlertsService) {

    this.alertService.alertState$.subscribe((state) => {
      this.alertState = state;
    });
  }

  closeAlert() {
    this.alertService.hideAlert();
  }
}
